import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCryptopunk: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cryptopunk,nft,pfp,profile,avatar"><path d="M7.25 2.75H16.75M5.75 4.25V9.25M4.25 10.75V13.75M5.75 13.75V21.25M11.25 21.25V19.25H16.75M18.25 17.75V6.75M18.25 6.75V4.25M18.25 6.75H5.75M18.25 6.75H21.25M10.75 13.75H10.76M14.25 15.25H11.75M10.7188 9.94444H10.7291M14.8438 9.94444H14.8541" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCryptopunk;
